import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';

const Status = props => {
    return () => {
        return (
            <div>
                <Tabs defaultActiveKey={1} id="sysStatus" bsStyle="pills">
                    <Tab eventKey={1} title="System Status & Notifications">
                        <iframe src="https://invintus-065.freshstatus.io/" width="100%" height="900px" frameBorder="0">
                        </iframe>
                    </Tab>
                    <Tab eventKey={2} title="Services Availability">
                        <iframe src="https://statuspage.freshping.io/14123-InvintusMedia/check/94044" width="100%" height="900px" frameBorder="0">
                        </iframe>
                    </Tab>
                    <Tab disabled title={<img height="35px" src="https://statuspage.freshping.io/badge/4d402343-862d-40d7-9789-7ad28575e32b?0.1019619883056857"/>}>
    
                    </Tab>
                </Tabs>
    
            </div>
    
    
        );
    }
    
}

export default Status;

{/* <iframe src="https://invintus-support.freshdesk.com/support/home" width="100%" height="900px" frameBorder="0"></iframe> */}